var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"c-start text-tundora-500 text-center font-medium italic text-4xl py-12"},[_vm._v("\n    "+_vm._s(_vm.model.heading)+"\n")])}
var staticRenderFns = []

export { render, staticRenderFns }